export default __webpack_public_path__ + "static/media/logo.eaf4865c.png";